// Runs `task` over `items` in order, with at most `limit` in flight. Items
// start in list order, so earlier items are served first.
export async function forEachWithConcurrency(items, limit, task) {
  let next = 0;
  const worker = async () => {
    while (next < items.length) {
      const item = items[next];
      next += 1;
      await task(item);
    }
  };
  await Promise.all(
    Array.from({ length: Math.min(limit, items.length) }, worker)
  );
}
